import { useState, useEffect } from "react";
import { Box } from "@chakra-ui/react";
import { Link } from "react-router-dom";
import "./Navbar.css";

const Navbar = () => {

    const [news, setNews] = useState("");
    const [matches, setMatches] = useState("");
    const [players, setPlayers] = useState("");

    useEffect(() => {
        switch(window.location.pathname){
            case "/" :
                setNews("news");
                setMatches("normal-text");
                setPlayers("normal-text");
            break;

            case "/matches" :
                setNews("normal-text");
                setMatches("matches");
                setPlayers("normal-text");
            break;

            case "/live" :
                setNews("normal-text");
                setMatches("matches");
                setPlayers("normal-text");
            break;

            case "/recent/matches" :
                setNews("normal-text");
                setMatches("matches");
                setPlayers("normal-text");
            break;

            case "/standings" :
                setNews("normal-text");
                setMatches("matches");
                setPlayers("normal-text");
            break;

            case "/players" :
                setNews("normal-text");
                setMatches("normal-text");
                setPlayers("players");
            break;
            default: setNews("news");
        }
    },[]);

    function switchIndicator(){
        setTimeout(
            function(){
                window.location.reload();
            },1);
    }

    return(
        <Box display="flex" justifyContent="space-evenly" 
        fontSize="2xl" position="fixed" bottom="0" w="100%"
        py="2" bg="#171717">
            <Link onClick={switchIndicator} color={news} to="/">
            <Box className={news}>
            <i className="fas fa-home text-2xl block"></i>
            </Box>
            </Link>

            <Link onClick={switchIndicator} color={matches} to="/live">
            <Box className={matches}>
            <i className="fas fa-futbol text-2xl"></i>
            </Box>
            </Link>

            <Link onClick={switchIndicator} color={players} to="/players">
            <Box className={players}>
            <i className="fas fa-running text-2xl"></i>
            </Box>
            </Link>
        </Box>
    );
}

export default Navbar;